require('./style.less');

var Marionette = require('marionette'),
    Backbone = require('backbone'),
    _ = require('underscore'),
    moment = require('moment'),
    BasePage = require('../page'),
    PreventDragEventsMixin = require('../preventDragEventsMixin'),
    $ = require('jquery');

require('extendMoment');
require('extendJQuery'); // ( unselectable )


/**
 * TODO: make GOS INFO portion same as page info?
 * Note: different activity for these views in PDF mode with pages with URLs (they can't be downloaded) --
 * see PDF subclass below.
 * TODO: Could now have this inherit from page like the thumbnails views ... yes try it
 *
 */

var UnRenderableView = BasePage.extend({

    template: require('./unrenderablePage.hbs'),
    viewMode: 'base',

    NON_LOADING: 1,
    APPLY_TRANSFORM: 0,

    onRender: function() {

        BasePage.prototype.onRender.apply( this, arguments );
        this.ui.downloadBtn.unselectable();

    },

    // Note: not extending here now ...
    serializeData: function() {

        var m = this.model,

            isGosPageType =  m.hasGosInfo(),
            gosInfo = m.get('gosInfo'),
            url = m.getPageUrl(), /* for PDF MODE, THE CRE WON'T RENDER url pages -- so more conditions ... would only be used in PDF MODE */

            data = {
                viewMode: this.viewMode, /* see below -- class extended */
                pgNumber: m.get('number'),
                fmtCtime: moment.convertDBTimeToLocalTime( m.get('ctime') ),
                isGosPageType: isGosPageType,
                gosInfo: isGosPageType ? m.get('gosInfo') : null,
                url: url,
                showDownloadOriginalButton: this.options.vChannel.request('allowPageDownload', m ),
                showLargeDownloadWarning: m.isMultipartGosSkeleton()
            };

        return data;

    },
    ui: _.extend( {}, BasePage.prototype.ui, {
        downloadBtn: '.btn-download'
    }),
    /**
     * DVBC-805- Stop propagation of all mouse events catpured by dragScroll plugin.
     * The will allow the user to select text page info text in the view.
     * Not applicable to PDF mode, but doesn't hurt here.
     */
    events: _.extend( {},

        PreventDragEventsMixin, {

        // Note: this at the page level -- i guess pdf would be at the doc level
        'click @ui.downloadBtn': function () {
            this.options.vChannel.command('download', 'page', 'raw', this.model.get('number'));
        }

    })

});


var uDM = UnRenderableView.extend({
        viewMode: 'document'
    }),

    uPM = UnRenderableView.extend({
        viewMode: 'page',
        APPLY_SCALE: 0
    }),

    uPDFM = UnRenderableView.extend({

        APPLY_SCALE: 0,
        viewMode: 'pdf',

        ui: _.extend( {}, UnRenderableView.prototype.ui, {
            popUrlBtn: '.popUrl'
        }),

        events: _.extend( {}, UnRenderableView.prototype.events, {

            // Url pages not rendered by the CRE -- don't provide a download button for them but a launch url button.
            // (They won't be GOS).
            // For simplicity,  left url in serialize data of the inherited view --
            // it will either be a GOS page or a page with a non renderable page with a URL.
            // (view will show either a url with launch, or GOS info table with a download btn ).
            'click @ui.popUrlBtn': function() {
                window.open( this.model.getPageUrl() );
            }

        })

});




module.exports = {
    base: UnRenderableView,
    document: uDM,
    page: uPM,
    pdf: uPDFM
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/page/unRenderable/unrenderablePg.js
 ** module id = 452
 ** module chunks = 0
 **/